var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"#e1e1e1"}},[_c('v-card-title',{staticClass:"d-flex justify-center"},[_vm._v("Total Inventory")]),_c('v-card-text',{staticClass:"text-center"},[_c('h1',[_vm._v(_vm._s(_vm.totalRecords))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }